module.exports = __webpack_public_path__ + "assets/img/btn-detail-61edec34.png";